import Vue from "vue";
export default Vue.extend({
    props: {
        col: {
            type: String,
            required: true,
        },
        uniqueKey: {
            type: String,
            required: true,
        },
    },
});
